<template>
  <div class="ActiveUserList DesktopOnly">
    <UsernameRow
      v-for="(u, clientID) in activeUsers"
      v-bind:key="clientID"
      v-bind:username="u.username || 'anonymous'"
      v-bind:color="u.color"
    ></UsernameRow>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import { UserInfo } from "@/wbcontroller/types/UserInfo";
import UsernameRow from "@/components/UsernameRow.vue";

@Component({ components: { UsernameRow } })
export default class ActiveUserList extends Vue {
  @State activeUsers!: Record<string, UserInfo>;

  get hasActiveUsers(): boolean {
    return Object.keys(this.activeUsers).length > 0;
  }
}
</script>

<style scoped lang="scss">
.ActiveUserList {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  pointer-events: none;

  display: flex;

  @media (min-width: 768px) {
    left: 50px;
    top: auto;
    bottom: 0;
    overflow: auto;
    flex-direction: row;
  }
}
</style>
